import {Injectable, inject} from '@angular/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {AppicSnackBarComponent} from '../shared/appic-snackbar/appic-snackbar.component';

export enum AlertType {
  Danger = 0,
  Success = 1,
  Info = 2,
}

const PANEL_CLASS: Record<AlertType, string> = {
  [AlertType.Danger]: 'snackbar-error',
  [AlertType.Success]: 'snackbar-success',
  [AlertType.Info]: 'snackbar-info',
};

const SNACKBAR_DURATION = 10;

@Injectable({providedIn: 'root'})
export class LayoutAlertService {
  private snackBar = inject(MatSnackBar);

  setAlert(text: string, type: AlertType, timeout = 0) {
    this.snackBar.dismiss();
    this.snackBar.openFromComponent(AppicSnackBarComponent, {
      data: {message: text, duration: SNACKBAR_DURATION},
      panelClass: ['appic-snackbar', PANEL_CLASS[type]],
    });
  }

  success(text: string, timeout = 0) {
    this.setAlert(text, AlertType.Success, timeout);
  }

  error(text: string, timeout = 0) {
    this.setAlert(text, AlertType.Danger, timeout);
  }

  info(text: string, timeout = 0) {
    this.setAlert(text, AlertType.Info, timeout);
  }
}
